function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import Notification from './Notification';
const useStyles = makeStyles(_ref => {
  let {
    palette
  } = _ref;
  return {
    root: {
      position: 'sticky'
    },
    variantSuccess: {
      backgroundColor: palette.success.main
    },
    variantError: {
      backgroundColor: palette.error.main
    },
    variantInfo: {
      backgroundColor: palette.info.main
    },
    variantWarning: {
      backgroundColor: palette.warning.main
    }
  };
});
const Snackbar = _ref2 => {
  let {
    children,
    ...props
  } = _ref2;
  const theme = useTheme();
  const classes = useStyles(theme);
  return /*#__PURE__*/React.createElement(SnackbarProvider, _extends({
    classes: classes
  }, props), children, /*#__PURE__*/React.createElement(Notification, null));
};
export default Snackbar;